// extracted by extract-css-chunks-webpack-plugin
module.exports = {"overflowFade":"overflowFade_VtoIq"};